import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreSkills } from "../../api/apiSkills";
import parseError from "../../utils/parseError";

/**
 * Hook لاستعادة جماعية للمهارات
 */
export function useRestoreAllSkills() {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllSkillsMutate,
        isPending,
    } = useMutation({
        mutationFn: massRestoreSkills,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["skills"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore skills");
        },
    });

    return {
        restoreAllSkillsMutate,
        isPending,
    };
}